import React from "react"
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import ContactPageIcon from '@mui/icons-material/ContactPage';
import MessageIcon from '@mui/icons-material/Message';
import { email, sms, tel, 
    // whatsapp 
} from "../functions";
import { PHONE } from ".";
// import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { ErrorColor, InfoColor, NeutralColor, PrimaryColor, SecondaryColor, SuccessColor, WarningColor } from "./colors";
import DiscordIcon from "../../components/DiscordIcon";

export const professional =
    [
        {
            title: "Resume",
            href: require("../../assets/documents/resume.pdf"),
            icon: <ContactPageIcon htmlColor={ErrorColor.main}/>
        },
        {
            title: "Email",
            href: email("alanngo673@gmail.com"),
            icon: <EmailIcon htmlColor={WarningColor.main}/>
        },
        {
            title: `Call`,
            href: tel(PHONE),
            icon: <PhoneIcon htmlColor={SuccessColor.main}/>
        },
        {
            title: `Text`,
            href: sms(PHONE),
            icon: <MessageIcon  htmlColor={PrimaryColor.dark}/>
        },
        {
            title: "LinkedIn",
            href: "https://www.linkedin.com/in/alan-ngo-77338a150/",
            icon: <LinkedInIcon  htmlColor={InfoColor.dark}/>
        },
        {
            title: "Discord",
            href: "https://discordapp.com/users/768987740430663711",
            icon: <DiscordIcon  htmlColor={SecondaryColor.dark}/>
        },
        {
            title: "GitHub",
            href: "https://github.com/alanngo",
            icon: <GitHubIcon  htmlColor={NeutralColor.light}/>
        },


    ]


